const styles = ['font-weight: bold; color: red', 'color: orange', 'font-weight: bold; color: red']

const printFunctionCall = (name: string, args?: Array<any>): void =>
    console.log(`➜ %c${name}(%c${args ? args.map((value) => JSON.stringify(value)).join(', ') : ''}%c)`, ...styles)

export default printFunctionCall
